import { BaseManager } from "./BaseManager.js";

export class HistoryManager extends BaseManager {
  constructor(manager) {
    super(manager);
  }
  init(manager) {
    super.init(manager);

    this.maxCount = 100; //记录的最大操作步数

    this.historyDisabled = false; //是否允许操作记录  初始禁止，初始化完成后再开启

    this.undoStack = []; //撤销栈

    this.redoStack = []; //重做栈
  }

  update(dt) {
    super.update(dt);
  }

  clear() {
    super.clear();

    for (var i = 0; i < this.undoStack.length; i++) {
      this.undoStack[i].clear();
    }
    this.undoStack = null;
    for (var i = 0; i < this.redoStack.length; i++) {
      this.redoStack[i].clear();
    }
    this.redoStack = null;
  }

  /**
   * 将操作加入撤销栈
   * @param {*} cmd
   */
  push(cmd) {
    if (cmd && this.historyDisabled) {
      //console.error("添加历史记录", cmd);
      this.undoStack.push(cmd);
      if (this.undoStack.length > this.maxCount) {
        let del = this.undoStack[0];
        del.clear();
        this.undoStack.splice(0, 1);
      }
    }
  }

  /**
   * 撤销历史记录最后一个操作
   */
  undo() {
    if (this.historyDisabled && this.undoStack.length > 0) {
      let cmd = this.undoStack[this.undoStack.length - 1];
      cmd.undo();
      //console.log("撤销历史记录", cmd);
      this.undoStack.splice(this.undoStack.length - 1, 1);
      this.redoStack.push(cmd);
      if (this.redoStack.length > this.maxCount) {
        let del = this.redoStack[0];
        del.clear();
        this.redoStack.splice(0, 1);
      }
    }
  }

  /**
   * 重做
   */
  redo() {
    if (this.historyDisabled && this.redoStack.length > 0) {
      let cmd = this.redoStack[this.redoStack.length - 1];
      cmd.redo();
      //console.log("重做历史记录", cmd);
      this.redoStack.splice(this.redoStack.length - 1, 1);
      this.undoStack.push(cmd);
      if (this.undoStack.length > this.maxCount) {
        let del = this.undoStack[0];
        del.clear();
        this.undoStack.splice(0, 1);
      }
    }
  }
}
